import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as XLSX from 'xlsx';
import { Workbook, Border, CellValue, Fill } from 'exceljs';
import * as fs from 'file-saver';
import * as JSZip from 'jszip';
import { Component, Inject, OnInit } from '@angular/core';
import { TokenService } from '../service/token.service';
import { GlobalService } from '../service/global.service';
import { environment } from 'src/environments/environment';
import { ReportForAccountingDaysInMonthInfo, ReportForAccountingViewInfo } from '../model/reportForAccounting.model';
import { EmpInfo } from '../model/emp.model';
import { SimpleTextInfo } from '../model/simpleTextInfo.model';
import { LookupInfo } from '../model/lookup.model';
import { TimeSheetMappingProjectInfo } from '../model/timesheetMappingProject.model';
import { TimeSheetExportInfo, TimeSheetExportReturnInfo } from '../model/TimeSheetExportInfo.model';
import { ReportTimesheetSummaryInfo, ReportTimesheetSummaryViewInfo } from '../model/reportTimesheetSummary.model';
import { DatePipe, formatDate } from '@angular/common';
import { debug } from 'console';
import { last } from 'rxjs/operators';

type TimeSheetReport = TimeSheetExportReturnInfo;

// 2. กำหนด Interface ที่ใช้ภายใน Component นี้เท่านั้น (ไม่มี 'export')
interface ExcelFileContent {
  fileName: string; 
  header: {
    ProjectCode: string;
    ProjectName: string;
    EmpName: string;
    EmpRole: string;
    Month: string;
    Year: number;
  };
  details: TimeSheetReport[]; // ใช้ Type Alias หรือ TimeSheetExportReturnInfo โดยตรง
  totalHours: number; 
}

@Component({
  selector: 'app-timesheet-export',
  templateUrl: './timesheet-export.component.html',
  styleUrls: ['./timesheet-export.component.css']
})
export class TimesheetExportComponent implements OnInit {
  baseurl: string;

  //Primary data
  ReportView: ReportTimesheetSummaryViewInfo;

  ListMonth: string[] = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];

  //Search Conditions
  ListEmployeeCode: string[] = [];
  ProjectList: TimeSheetMappingProjectInfo[] = [];

  txtSchEmployee: string = "";
  txtSchYear: string = "";
  txtSchFormat: string = "1";
  txtSchFormatCurrent: string = "1";
  txtSchDateFrom: string = "";
  txtSchDateTo: string = "";
  txtProjectCode: string = null;

  txtSearchProjectCode: string = null;
  txtSearchProjectName: string = null;

  txtSubmittedEmployee: EmpInfo[] = [];
  txtSubmittedYear: string = "";
  selectedProjects: TimeSheetMappingProjectInfo[] = [];

  currentPageNumberProject: number = 1;
  totalPagesProject: number = 0;
  totalItems: number = 0
  PageSizeProject: number = 10;

  TimeSheetReportList: TimeSheetExportReturnInfo[] = [];
  groupedReports: ExcelFileContent[] = [];

  //Export
  fileName = 'TestSheet.xlsx'; 

  //empselect
  employeeselectrun: boolean = false;
  selectedemp: EmpInfo[] = [];

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private GlobalService: GlobalService, private TokenService: TokenService) { 
    this.baseurl = environment.base_api;

    GlobalService.CheckPagingAccessRights();
  }

  async ngOnInit(): Promise<void> {
    await this.LoadProjectList("Y");
  }
  
  OnClearSearch_Click() {
    this.txtSchYear = null;
    this.txtSchFormat = "1";
    this.txtSchEmployee = null;
    this.selectedemp = [];
    this.ReportView = null;
    this.txtSchDateFrom = null;
    this.txtSchDateTo = null;
    this.txtProjectCode = null;
    this.selectedProjects = [];
  }

  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput
  }
  
  selectedEmp(event) {
    //console.log("SELECTED EMP")
  
    this.selectedemp = event;
    //console.log(this.selectedemp)
  }
  
  empselect() {
    this.employeeselectrun = true;
    this.txtSchEmployee = ""
    this.selectedemp = [];
    this.ReportView = null;
    $('#ModalEmpSelect').modal();
  }
  
  async saveEmpSelect() {
  
      $('#ModalEmpSelect').modal('hide');
      this.employeeselectrun = false;
  
      this.txtSchEmployee = this.selectedemp.length + ' employee(s) selected'
  
      //console.log('txtSchEmployee', this.selectedemp);

      //if (this.selectedemp != null) {
      //  // hide modal Assign PM
      //  $('#ModalEmpSelect').modal('hide');
      //  this.employeeselectrun = false;
  
  
      //  this.onChanges(this.employeeselectreturnto, true, true)
  
      //  this.selectedemp = null;
  
      //} else {
      //  alert("Please select an employee")
      //}
  
  }

  projectselect() {
    this.txtProjectCode = ""
    $('#ModalProjectSelect').modal();
  }

  ClearSearchProject() {
    this.txtSearchProjectCode = null;
    this.txtSearchProjectName = null;
    this.PageSizeProject = 10;  
    this.LoadProjectList("Y");
  }

  async LoadProjectList(bySearch: string | null = null) {
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      if (bySearch === "Y") {
        this.currentPageNumberProject = 1;
      }

      const objectjson = {
        ProjectCode: this.checkUndefinedString(this.txtSearchProjectCode) ? this.txtSearchProjectCode : null,
        ProjectName: this.checkUndefinedString(this.txtSearchProjectName) ? this.txtSearchProjectName : null,
        rowFetch: this.PageSizeProject,
        rowOFFSet: ((this.currentPageNumberProject - 1) < 0 ? 0 : (this.currentPageNumberProject - 1)) * this.PageSizeProject
      };

      const response = await this.httpClient.post<any>(this.baseurl + "TimeSheet/GetAllProjectsInTimeSheet",
        JSON.stringify(objectjson), httpOptions).toPromise();

      this.ProjectList = response;
      this.totalItems = this.ProjectList.length;

      if (this.ProjectList.length <= 0) {
        this.currentPageNumberProject = 0;
      } else {
        if (this.currentPageNumberProject == 0) this.currentPageNumberProject = 1;
        this.totalItems = Number(this.ProjectList[0].itemTotal);
      }

      //console.log('ProjectList:', this.ProjectList);

      this.totalPagesProject = Math.ceil(this.totalItems / this.PageSizeProject);
    } catch (error) {
      console.error('Error loading project:', error);
      alert('An error occurred while loading project data. Please try again.');
    } finally {
    }
  }

  OnLoadProjectList(target = null) {
    if (target != null) {
      this.currentPageNumberProject = target.currentPageNumber;
      this.totalPagesProject = target.totalPages;
    }

    this.LoadProjectList();
  }

  btnClick_SearchProjectList() {
    this.PageSizeProject = 10;
    this.LoadProjectList("Y");
  }

  clearProjectelect() {
    this.txtSearchProjectCode = null;
    this.txtSearchProjectName = null;
    this.PageSizeProject = 10;
    this.LoadProjectList("Y");
  }

  btnClick_showProjectAll() {
    this.txtSearchProjectCode = null;
    this.txtSearchProjectName = null;
    this.PageSizeProject = 9999;
    this.LoadProjectList("Y");
  }

  chkallProjectclick(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    const checkboxes = document.getElementsByName('checkboxproject') as NodeListOf<HTMLInputElement>;

    checkboxes.forEach(cb => {
      cb.checked = checked;
    });

    this.btnClick_multiselectProject();
  }

  btnClick_multiselectProject() {
    var listselected = $('[name="checkboxproject"]:checked').filter(function () {
      return !(this as HTMLInputElement).disabled
    });

    let projlist = [];

    for (let x = 0; x < listselected.length; x++) {
      projlist.push((<HTMLInputElement>listselected[x]).value);
    }

    this.selectedProjects = this.ProjectList.filter(emp => projlist.includes(emp.ProjectCode));
    //console.log('Selected Projects:', this.selectedProjects);
  }

  async saveProjectelect() {
      $('#ModalProjectSelect').modal('hide');
      
      this.txtProjectCode = this.selectedProjects.length + ' project(s) selected'
      //console.log('txtProjectCode', this.selectedProjects);
  }

  async OnSearch_Click() {
      // if(!this.txtSchEmployee || !this.txtSchYear) {
      //   alert("Please select employee and year before submit")
      //   return;
      // }
    const isDateFromMissing = !this.txtSchDateFrom;
    const isDateToMissing = !this.txtSchDateTo;

    if (isDateFromMissing && isDateToMissing) {
        alert('กรุณาระบุ "Date From" และ "Date To" ให้ครบถ้วน');
        return;
    } else if (isDateFromMissing) {
        alert('กรุณาระบุ "Date From"');
        return;
    } else if (isDateToMissing) {
        alert('กรุณาระบุ "Date To"');
        return;
    }

    const fromDate = new Date(this.txtSchDateFrom);
    const toDate = new Date(this.txtSchDateTo);

    if (toDate < fromDate) {
      alert('"Date To" cannot be earlier than "Date From"');
      return;
    }
  
      //console.log('EmpSelectedList', this.selectedemp);
      //console.log('ProjectSelectedList', this.selectedProjects);
      //console.log('dateForm', this.txtSchDateFrom);
      //console.log('dateTo', this.txtSchDateTo);

      const empCodeList: string[] = this.selectedemp.filter(emp => emp.EmpCode)        // กรองเฉพาะที่มี EmpCode
                                                    .map(emp => emp.EmpCode);

      const projectCodeList: string[] = this.selectedProjects.filter(proj => proj.ProjectCode) // กรองเฉพาะที่มี ProjectCode
                                                              .map(proj => proj.ProjectCode);

      const auth_token = await this.TokenService.RefreshToken();

    if (!auth_token) {
      console.error('No valid token');
      alert('Session expired. Please login again.');
      return;
    }

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    const objectjson = 
      {
        DateFrom: this.txtSchDateFrom,  // ตัวอย่าง "2025-10-01"
        DateTo: this.txtSchDateTo,      // ตัวอย่าง "2025-10-31"
        EmpCodeList: empCodeList,
        ProjectCodeList: projectCodeList
      };

      console.log('TimeSheetExportInfo JSON:', JSON.stringify(objectjson));
    // POST ไป API และรับผลลัพธ์
    const response = await this.httpClient.post<TimeSheetExportReturnInfo[]>(this.baseurl + "TimeSheet/TimeSheetReportForExport",
                        JSON.stringify(objectjson), httpOptions).toPromise();

    this.TimeSheetReportList = response || [];
    console.log('TimeSheetReportList:', this.TimeSheetReportList);

    if (this.TimeSheetReportList.length === 0) {
        alert('ไม่พบข้อมูล Time Sheet ตามเงื่อนไขที่กำหนด');
        this.groupedReports = [];
        return;
    }

    // 3. [STEP ใหม่]: จัดกลุ่มข้อมูล
    this.groupedReports = this.processReportList(this.TimeSheetReportList);

    // 4. [STEP ใหม่]: สร้างและส่งออกไฟล์ Excel
    await this.exportExcelFiles();
  }

  processReportList(reports: TimeSheetReport[]): ExcelFileContent[] {
    // 1. จัดกลุ่มด้วย EmpCode, Year, และ Month (key = "DP0002|2025|Sep")
    const groupsMap = new Map<string, TimeSheetReport[]>();
    
    reports.forEach(item => {
        const empNameClean = item.EmpName ? item.EmpName.replace(/\r\n|\n/g, '').trim() : '';
        
        // Key: Grouping โดย EmpCode, Year, และ Month (นี่คือ 1 Tab Sheet)
        const key = `${item.EmpCode}|${item.Year}|${item.Month}`; 
        item.EmpName = empNameClean; 

        if (!groupsMap.has(key)) {
            groupsMap.set(key, []);
        }
        groupsMap.get(key)!.push(item);
    });

    const result: ExcelFileContent[] = [];
    groupsMap.forEach((details) => {
        const firstItem = details[0]; 
        const totalHours = details.reduce((sum, current) => sum + current.Hours, 0);

        // กรอง Project Codes ที่ไม่ซ้ำกันทั้งหมด และรวมด้วย comma
        const distinctProjectCodes = Array.from(new Set(details.map(d => d.ProjectCode))).join(', ');
        
        // ชื่อไฟล์ (fileName) ถูกกำหนดไว้เพื่อใช้ในการจัดเรียงเท่านั้น
        const fileName = `${firstItem.EmpCode}_${firstItem.Month}_${firstItem.Year}.xlsx`; 
        
        result.push({
            fileName: fileName,
            header: {
                ProjectCode: distinctProjectCodes, 
                ProjectName: firstItem.ProjectName, 
                EmpName: firstItem.EmpName,
                EmpRole: firstItem.EmpRole,
                Month: firstItem.Month,
                Year: firstItem.Year
            },
            details: details.sort((a, b) => new Date(a.TimeSheetDate).getTime() - new Date(b.TimeSheetDate).getTime()),
            totalHours: totalHours
        });
    });
    
    // 2. [สำคัญ] จัดเรียงผลลัพธ์: EmpCode > Year > Month เพื่อใช้ในการสร้างไฟล์แบบวนซ้ำ
    const monthOrder: { [key: string]: number } = { 'Jan': 1, 'Feb': 2, 'Mar': 3, 'Apr': 4, 'May': 5, 'Jun': 6, 'Jul': 7, 'Aug': 8, 'Sep': 9, 'Oct': 10, 'Nov': 11, 'Dec': 12 };
    
    result.sort((a, b) => {
        const empCodeA = a.details[0].EmpCode;
        const empCodeB = b.details[0].EmpCode;

        if (empCodeA !== empCodeB) {
            return empCodeA.localeCompare(empCodeB); // จัดเรียงตาม EmpCode (File)
        }

        if (a.header.Year !== b.header.Year) {
            return a.header.Year - b.header.Year; // จัดเรียงตาม Year (Tab)
        }
        
        const monthA = a.header.Month;
        const monthB = b.header.Month;
        
        return (monthOrder[monthA] || 0) - (monthOrder[monthB] || 0); // จัดเรียงตาม Month (Tab)
    });
    
    return result;
}

  async exportExcelFiles() {
    // กำหนดชื่อฟอนต์ที่จะใช้ทั่วทั้งไฟล์
    const FIXED_FONT_NAME = 'Century Gothic';
    const FIXED_FONT_SIZE = 9;
    
    // ARGB Color Constants
    const COLOR_BLACK_LIGHTER_35 = 'FF595959'; // Black Lighter 35% (สำหรับ Title Font)
    const COLOR_HEADER_LABEL_BACKGROUND = 'FFACB9CA'; // Background Color: #ACB9CA (Header Labels)
    
    // กำหนด ARGB Color สำหรับ Footer Labels
    const COLOR_FOOTER_LABEL_1_BACKGROUND = 'FF222B35'; // Background: #222B35
    const COLOR_FOOTER_LABEL_2_BACKGROUND = 'FF333F4F'; // Background: #333F4F
    const COLOR_WHITE = 'FFFFFFFF'; // Font Color: White

    // Mapping 1: ชื่อเดือนเต็ม ภาษาไทย (ใช้สำหรับ Cell F3)
    const monthMapping: { [key: string]: string } = {
        'Jan': 'January', 'Feb': 'February', 'Mar': 'March', 'Apr': 'April', 
        'May': 'May', 'Jun': 'June', 'Jul': 'July', 'Aug': 'August', 
        'Sep': 'September', 'Oct': 'October', 'Nov': 'November', 'Dec': 'December',
    };
    
    // Mapping 2: ชื่อย่อเดือน ภาษาไทย (ใช้สำ้ญา Sheet Name)
    const monthShortMapping: { [key: string]: string } = {
        'Jan': 'ม.ค.', 'Feb': 'ก.พ.', 'Mar': 'มี.ค.', 'Apr': 'เม.ย.', 
        'May': 'พ.ค.', 'Jun': 'มิ.ย.', 'Jul': 'ก.ค.', 'Aug': 'ส.ค.', 
        'Sep': 'ก.ย.', 'Oct': 'ต.ค.', 'Nov': 'พ.ย.', 'Dec': 'ธ.ค.',
    };
    
    const thinBorder: Partial<Border> = { style: 'thin', color: { argb: '00000000' } };
    const allBorders: { [key: string]: Partial<Border> } = {
        top: thinBorder, bottom: thinBorder, left: thinBorder, right: thinBorder
    };
    
    // Style สำหรับ Detail Header Row (ใช้ Font Size 9)
    const detailHeaderStyle = {
        font: { 
            bold: true,
            name: FIXED_FONT_NAME, 
            size: FIXED_FONT_SIZE 
        },
        alignment: { horizontal: 'center' as const, vertical: 'middle' as const, wrapText: true } as const,
        fill: { type: 'pattern' as const, pattern: 'solid' as const, fgColor: { argb: COLOR_HEADER_LABEL_BACKGROUND } as const } 
    };
    
    // ฟังก์ชันช่วยสำหรับกำหนด Style ใน Header Block (B3:H5)
    const applyHeaderStyle = (cell: any, isLabel: boolean = false) => { 
        Object.assign(cell, { 
            border: allBorders,
            font: { 
                name: FIXED_FONT_NAME, 
                size: FIXED_FONT_SIZE, 
                bold: isLabel, 
            }
        });

        // กำหนด Background #ACB9CA เฉพาะ Label
        if (isLabel) {
            Object.assign(cell, {
                fill: { type: 'pattern' as const, pattern: 'solid' as const, fgColor: { argb: COLOR_HEADER_LABEL_BACKGROUND } as const }
            });
        }
    };
    
    let currentWorkbook: Workbook | null = null;
    let currentEmpCode: string | null = null;
    let currentEmpName: string | null = null; 
    let reportsInCurrentWorkbook: ExcelFileContent[] = [];
    
    // 💡 **NEW**: Store file data for ZIP creation
    const filesToZip: { fileName: string, buffer: ArrayBuffer }[] = [];

    for (const group of this.groupedReports) {
        const nextEmpCode = group.details[0].EmpCode; 
        const nextEmpName = group.header.EmpName;

        if (nextEmpCode !== currentEmpCode) {
            // Save previous workbook to ZIP instead of downloading
            if (currentWorkbook && currentEmpCode) {
                try {
                    const buffer = await currentWorkbook.xlsx.writeBuffer();
                    const finalFileName = this.generateFileName(currentEmpName!, reportsInCurrentWorkbook);
                    
                    // 💡 **NEW**: Add to ZIP array instead of downloading
                    filesToZip.push({ fileName: finalFileName, buffer });
                } catch (error) {
                    console.error(`Error creating file ${currentEmpCode}.xlsx:`, error);
                }
                
                reportsInCurrentWorkbook = []; 
            }
            currentWorkbook = new Workbook();
            currentEmpCode = nextEmpCode;
            currentEmpName = nextEmpName;
        }
        
        reportsInCurrentWorkbook.push(group); 

        const monthEnForSheet = group.header.Month.substring(0, 3);
        const mappedMonthThForSheet = monthShortMapping[monthEnForSheet] || group.header.Month;
        const worksheetName = mappedMonthThForSheet.substring(0, 31); 
        const worksheet = currentWorkbook!.addWorksheet(worksheetName); 
        
        // 2.1 กำหนดความกว้างคอลัมน์ (A-H)
        worksheet.columns = [
            { width: 3 }, { width: 12 }, { width: 18 }, { width: 37 }, 
            { width: 10 }, { width: 25 }, { width: 21 }, 
            { width: 10 }
        ];

        // Title หลัก (A2:H2) 
        worksheet.mergeCells('A2:H2');
        const mainTitleCell = worksheet.getCell('A2');
        mainTitleCell.value = 'MONTHLY PROJECT RESOURCE TIMESHEET';
        Object.assign(mainTitleCell, { 
            font: { 
                bold: true, 
                size: 22, 
                name: FIXED_FONT_NAME,
                color: { argb: COLOR_BLACK_LIGHTER_35 }
            }, 
            alignment: { horizontal: 'center' as const, vertical: 'middle' as const } 
        });

        // 2.2 Header (แถว 3-5)
        
        // Column B (Labels)
        applyHeaderStyle(worksheet.getCell('B3'), true); worksheet.getCell('B3').value = 'Project'; 
        applyHeaderStyle(worksheet.getCell('B4'), true); worksheet.getCell('B4').value = 'Name'; 
        applyHeaderStyle(worksheet.getCell('B5'), true); worksheet.getCell('B5').value = 'Role'; 
        
        // Column E (Labels)
        applyHeaderStyle(worksheet.getCell('E3'), true); worksheet.getCell('E3').value = 'MONTH'; 
        applyHeaderStyle(worksheet.getCell('E4'), true); worksheet.getCell('E4').value = 'YEAR'; 
        applyHeaderStyle(worksheet.getCell('E5'), true); worksheet.getCell('E5').value = 'DATE DUE'; 
        
        // Column G (Labels)
        applyHeaderStyle(worksheet.getCell('G3'), true); worksheet.getCell('G3').value = 'HOURS REQUIRED'; 
        
        // G4 (Label, มี Wrap Text)
        const g4Cell = worksheet.getCell('G4');
        applyHeaderStyle(g4Cell, true); 
        g4Cell.value = 'HOURS COMPLETED\nAT START OF MONTH'; 
        g4Cell.alignment = { wrapText: true, vertical: 'middle' };
        
        // G5 (Label, มี Wrap Text)
        const g5Cell = worksheet.getCell('G5');
        applyHeaderStyle(g5Cell, true); 
        g5Cell.value = 'BALANCE OF HOURS\nAT START OF MONTH'; 
        g5Cell.alignment = { wrapText: true, vertical: 'middle' };
        
        // C3:D3 (Value)
        worksheet.mergeCells('C3:D3'); applyHeaderStyle(worksheet.getCell('C3'), false); worksheet.getCell('C3').value = group.header.ProjectCode;
        // C4:D4 (Value)
        worksheet.mergeCells('C4:D4'); applyHeaderStyle(worksheet.getCell('C4'), false); worksheet.getCell('C4').value = group.header.EmpName;
        // C5:D5 (Value)
        worksheet.mergeCells('C5:D5'); applyHeaderStyle(worksheet.getCell('C5'), false); worksheet.getCell('C5').value = group.header.EmpRole;

        const monthEn = group.header.Month.substring(0, 3);
        // F3 (Value)
        applyHeaderStyle(worksheet.getCell('F3'), false); worksheet.getCell('F3').value = monthMapping[monthEn] || group.header.Month; 
        
        // F4 (Value)
        applyHeaderStyle(worksheet.getCell('F4'), false); 
        worksheet.getCell('F4').value = group.header.Year; 
        worksheet.getCell('F4').alignment = { horizontal: 'left' }; 
        
        // F5 (Value)
        applyHeaderStyle(worksheet.getCell('F5'), false); worksheet.getCell('F5').value = ''; 

        // H3, H4, H5: Hours Value (ทศนิยม 2 ตำแหน่ง)
        applyHeaderStyle(worksheet.getCell('H3'), false); worksheet.getCell('H3').value = 0; worksheet.getCell('H3').numFmt = '0.00';
        applyHeaderStyle(worksheet.getCell('H4'), false); worksheet.getCell('H4').value = 0; worksheet.getCell('H4').numFmt = '0.00';
        
        // H5 (Value) - Formula: =H3-H4
        applyHeaderStyle(worksheet.getCell('H5'), false); 
        worksheet.getCell('H5').value = { formula: 'H3-H4', result: 0 } as CellValue; 
        worksheet.getCell('H5').numFmt = '0.00'; 
        
        // 2.3 Detail Header (แถว 7)
        worksheet.mergeCells('D7:E7'); 
        worksheet.mergeCells('G7:H7'); 
        
        Object.assign(worksheet.getCell('B7'), detailHeaderStyle, { value: 'DATE' }); 
        Object.assign(worksheet.getCell('C7'), detailHeaderStyle, { value: 'PROJECT CODE' }); 
        Object.assign(worksheet.getCell('D7'), detailHeaderStyle, { value: 'TASK' }); 
        Object.assign(worksheet.getCell('F7'), detailHeaderStyle, { value: 'HOURS' }); 
        Object.assign(worksheet.getCell('G7'), detailHeaderStyle, { value: 'NOTE' }); 
        
        worksheet.getRow(7).eachCell({ includeEmpty: true }, (cell, colIndex) => { 
            if (colIndex >= 2 && colIndex <= 8) { 
                cell.border = allBorders; 
            }
        });

        // 2.4 เขียนข้อมูล Detail (เริ่มต้นที่แถว 8)
        let currentRow = 8; 
        const detailRowStyle = { font: { name: FIXED_FONT_NAME, size: FIXED_FONT_SIZE } }; 
        
        for (const detail of group.details) { 
            // B: DATE
            Object.assign(worksheet.getCell(`B${currentRow}`), detailRowStyle, { value: formatDate(detail.TimeSheetDate, 'yyyy-MM-dd', 'en-US'), border: allBorders }); 

            // C: ProjectCode Value
            Object.assign(worksheet.getCell(`C${currentRow}`), detailRowStyle, { 
                value: detail.ProjectCode, 
                border: allBorders,
                alignment: { wrapText: true, vertical: 'top' } 
            });
            
            // D:E: TASK (Merged)
            worksheet.mergeCells(`D${currentRow}:E${currentRow}`);
            Object.assign(worksheet.getCell(`D${currentRow}`), detailRowStyle, { 
                value: detail.Detail, 
                border: allBorders, 
                alignment: { wrapText: true, vertical: 'top' } 
            });
            
            // F: HOURS: ทศนิยม 2 ตำแหน่ง
            Object.assign(worksheet.getCell(`F${currentRow}`), detailRowStyle, { value: detail.Hours, numFmt: '0.00', border: allBorders });

            // G:H: NOTE (Merged)
            worksheet.mergeCells(`G${currentRow}:H${currentRow}`);
            Object.assign(worksheet.getCell(`G${currentRow}`), detailRowStyle, { border: allBorders });
            
            worksheet.getRow(currentRow).height = 20; 
            currentRow++;
        }
        
        // 3. Footer
        currentRow++; 

        // 3.2 Footer Row 2: แถวสรุปยอดรวม (Summary Row)
        const summaryRow = worksheet.getRow(currentRow);
        summaryRow.height = 20; 

        const footerSummaryStyle = { font: { bold: true, name: FIXED_FONT_NAME, size: FIXED_FONT_SIZE } };

        // B+C: END OF MONTH SUMMARY (Label - Bold, Size 9)
        worksheet.mergeCells(`B${currentRow}:C${currentRow}`);
        const endOfMonthCell = worksheet.getCell(`B${currentRow}`);
        endOfMonthCell.value = 'END OF MONTH SUMMARY';
        Object.assign(endOfMonthCell, footerSummaryStyle, { 
            font: { ...footerSummaryStyle.font, color: { argb: COLOR_WHITE } },
            fill: { type: 'pattern' as const, pattern: 'solid' as const, fgColor: { argb: COLOR_FOOTER_LABEL_1_BACKGROUND } as const },
            alignment: { horizontal: 'left' as const, vertical: 'middle' as const } 
        });

        // D+E: TOTAL RESOURCE HOURS COMPLETED THIS MONTH (Label - Bold, Size 9)
        worksheet.mergeCells(`D${currentRow}:E${currentRow}`);
        const totalHoursLabelCell = worksheet.getCell(`D${currentRow}`);
        totalHoursLabelCell.value = 'TOTAL RESOURCE HOURS COMPLETED THIS MONTH';
        Object.assign(totalHoursLabelCell, footerSummaryStyle, { 
            font: { ...footerSummaryStyle.font, color: { argb: COLOR_WHITE } },
            fill: { type: 'pattern' as const, pattern: 'solid' as const, fgColor: { argb: COLOR_FOOTER_LABEL_2_BACKGROUND } as const },
            alignment: { horizontal: 'right' as const, vertical: 'middle' as const } 
        });

        // F: Total Hours Value (Value - Bold, Size 9)
        const totalHoursValueCell = worksheet.getCell(`F${currentRow}`);
        totalHoursValueCell.value = group.totalHours; 
        totalHoursValueCell.numFmt = '0.00'; 
        Object.assign(totalHoursValueCell, footerSummaryStyle, { 
            alignment: { horizontal: 'right' as const, vertical: 'middle' as const } 
        });
        
        // G: BALANCE REMAINING (Label - Bold, Size 9)
        const balanceRemainingLabelCell = worksheet.getCell(`G${currentRow}`);
        balanceRemainingLabelCell.value = 'BALANCE REMAINING';
        Object.assign(balanceRemainingLabelCell, footerSummaryStyle, { 
            font: { ...footerSummaryStyle.font, color: { argb: COLOR_WHITE } },
            fill: { type: 'pattern' as const, pattern: 'solid' as const, fgColor: { argb: COLOR_FOOTER_LABEL_1_BACKGROUND } as const },
            alignment: { horizontal: 'center' as const, vertical: 'middle' as const } 
        });
        balanceRemainingLabelCell.border = allBorders; 

        // H: Value for BALANCE REMAINING (ตัวเลข 0.00)
        const balanceRemainingValueCell = worksheet.getCell(`H${currentRow}`);
        balanceRemainingValueCell.value = { formula: `H5-F${currentRow}`, result: 0 } as CellValue; 
        
        balanceRemainingValueCell.numFmt = '0.00';
        Object.assign(balanceRemainingValueCell, footerSummaryStyle, { 
            alignment: { horizontal: 'right' as const, vertical: 'middle' as const } 
        });
        balanceRemainingValueCell.border = allBorders; 
        
        summaryRow.eachCell({ includeEmpty: true }, (cell, colIndex) => { 
            if (colIndex >= 2 && colIndex <= 8) { 
                cell.border = allBorders; 
            }
        });
        
        currentRow++; 
    }

    // 4. บันทึก Workbook สุดท้ายที่ค้างอยู่ (ถ้ามี)
    if (currentWorkbook && currentEmpCode) {
        try {
            const buffer = await currentWorkbook.xlsx.writeBuffer();
            const finalFileName = this.generateFileName(currentEmpName!, reportsInCurrentWorkbook);
            
            // 💡 **NEW**: Add to ZIP array instead of downloading
            filesToZip.push({ fileName: finalFileName, buffer });
        } catch (error) {
            console.error(`Error creating final file ${currentEmpCode}.xlsx:`, error);
        }
    }
    
    // 💡 **NEW**: Create ZIP file and download
    if (filesToZip.length > 0) {
        try {
            const zip = new JSZip();
            
            // Add all files to ZIP
            filesToZip.forEach(file => {
                zip.file(file.fileName, file.buffer);
            });
            
            // Generate ZIP buffer
            const zipBuffer = await zip.generateAsync({ type: 'arraybuffer' });
            const zipData = new Blob([zipBuffer], { type: 'application/zip' });
            
            // Generate ZIP filename based on date range
            const zipFileName = `Timesheet_Export_${this.txtSchDateFrom}_to_${this.txtSchDateTo}.zip`;
            
            // Download ZIP file
            fs.saveAs(zipData, zipFileName);
            
            alert(`ส่งออกไฟล์ Excel ทั้งหมด ${filesToZip.length} ไฟล์ใน ZIP สำเร็จ.`);
        } catch (error) {
            console.error('Error creating ZIP file:', error);
            alert('เกิดข้อผิดพลาดในการสร้างไฟล์ ZIP');
        }
    } else {
        alert('ไม่มีไฟล์ที่จะส่งออก');
    }
}

  generateFileName(empName: string, reports: ExcelFileContent[]): string {
    const numMonths = reports.length;
    
    if (numMonths === 0) {
        return `Monthly Timesheet Unknown.xlsx`;
    }
    
    // รายงานถูกจัดเรียงตาม EmpCode > Year > Month อยู่แล้ว 
    const firstReport = reports[0];
    const lastReport = reports[numMonths - 1];
    
    // ดึงข้อมูลสำหรับช่วงเดือน
    const startMonth = firstReport.header.Month.substring(0, 3); 
    const startYear = String(firstReport.header.Year).substring(2); 
    
    let period: string;

    if (numMonths === 1) {
        // กรณีมี 1 เดือน: Jan 25
        period = `${startMonth} ${startYear}`;
    } else {
        // กรณีมีมากกว่า 1 เดือน: Jan 25 - Mar 25
        const endMonth = lastReport.header.Month.substring(0, 3); 
        const endYear = String(lastReport.header.Year).substring(2); 
        
        period = `${startMonth} ${startYear} - ${endMonth} ${endYear}`;
    }

    // รูปแบบที่ต้องการ: Monthly Timesheet John Doe Jan 25.xlsx
    return `Monthly Timesheet ${empName} ${period}.xlsx`;
}

}
